const INTRO_SESSION_KEY = 'oche-intro-shown';

export type IntroPhase = 'logo' | 'bubbles' | 'flood' | 'reveal' | 'done';

export function shouldSkipIntro(): boolean {
  if (typeof window === 'undefined') return true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;

  try {
    if (new URLSearchParams(window.location.search).has('intro')) return false;
    return sessionStorage.getItem(INTRO_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function markIntroShown(): void {
  try {
    sessionStorage.setItem(INTRO_SESSION_KEY, '1');
  } catch {
    /* private browsing */
  }
}

/** Total intro length before unmount (ms) - keep in sync with CSS animation delays. */
export const INTRO_DURATION_MS = 3800;

export const INTRO_TIMELINE = {
  logoMs: 500,
  bubblesMs: 1400,
  floodMs: 900,
  revealMs: 700,
} as const;
